import { fetch } from 'utils/api';

export const apiFetchConcepts = () => {
  return fetch({
    url: '/concepts',
    method: 'GET',
    dataType: 'concepts'
  });
};
